import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07d137d9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-config-page-view" }
const _hoisted_2 = {
  key: 0,
  class: "app-config-multi-page-top"
}
const _hoisted_3 = {
  key: 1,
  class: "app-config-multi-page-left"
}
const _hoisted_4 = { style: {"flex-grow":"1","background-color":"white","padding":"20px","border-radius":"5px"} }

import {computed, onMounted, ref, toRaw, watchEffect} from "vue";
import {
  AppConfigComponentAdType,
  AppConfigComponentType,
  AppConfigPage,
  AppConfigPageDetail,
  AppConfigPageType
} from "@/model/AppConfig";
import AppConfigAPI from "@/api/AppConfigAPI";
import {UIHandleGet} from "@/views/utils";
import AppConfigComponentDrawerComponent from "./drawer/AppConfigComponentDrawerComponent.vue";
import JTabs from "@/components/JTabs/JTabs.vue";
import JTabsContent from "@/components/JTabs/JTabsContent.vue";



const __default__ = {
  name: "AppConfigPageView"
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  id: {
    type: String,
    required: true
  },
  tabPosition: {
    type: String,
    required: false,
    default: 'top'
  },

  width: {
    type: String,
    default: 'var(--app-body-width)'
  }
},
  setup(__props) {

const props = __props




const activeName = ref<string>("")
const page = ref<AppConfigPageDetail>()
const loading = ref<boolean>()


const request = async () => {
  try {
    loading.value = true
    page.value = await UIHandleGet(AppConfigAPI.detail(props.id))
  } finally {
    loading.value = false
  }
}

watchEffect(() => {
  if (page.value && page.value.type === AppConfigPageType.MULTI && page.value.pages && page.value.pages.length > 0 && !activeName.value) {
    activeName.value = page.value.pages[0].id!
  }
})

const components = computed(() => {
  if (page.value?.components) {
    return page.value.components.filter((component) => {
      if (component.type == AppConfigComponentType.LIST ||
          component.type == AppConfigComponentType.LIST_GROUP ||
          component.type == AppConfigComponentType.NEWS) {
        return true
      }

      if (component.type == AppConfigComponentType.AD && component.ad?.type === AppConfigComponentAdType.PLAIN) {
        return true
      }

      return false
    })
  }

  return []
})

onMounted(async () => {
  await request()
})



return (_ctx: any,_cache: any) => {
  const _component_AppConfigPageView = _resolveComponent("AppConfigPageView", true)!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (page.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (__props.tabPosition === 'top')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (page.value.type === _unref(AppConfigPageType).MULTI)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createVNode(_component_el_tabs, {
                        modelValue: activeName.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(page.value.pages, (page) => {
                            return (_openBlock(), _createBlock(_component_el_tab_pane, {
                              lazy: true,
                              key: page.id,
                              label: page.name,
                              name: page.id
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_AppConfigPageView, {
                                  id: page.id
                                }, null, 8, ["id"])
                              ]),
                              _: 2
                            }, 1032, ["label", "name"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (__props.tabPosition === 'left')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(JTabs, {
                  direction: "vertical",
                  style: {"flex-shrink":"0","margin-right":"20px","background-color":"white","width":"180px","padding":"20px 20px 50px 20px","box-sizing":"border-box","border-radius":"5px"},
                  modelValue: activeName.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeName).value = $event)),
                  tabs: page.value.pages || []
                }, null, 8, ["modelValue", "tabs"]),
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(page.value.pages || [], (page) => {
                    return (_openBlock(), _createBlock(JTabsContent, {
                      key: page.id,
                      "active-value": activeName.value,
                      value: page.id
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_AppConfigPageView, {
                          width: "960px",
                          id: page.id
                        }, null, 8, ["id"])
                      ]),
                      _: 2
                    }, 1032, ["active-value", "value"]))
                  }), 128))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", {
                key: 2,
                style: _normalizeStyle([{width: __props.width}, {"padding-bottom":"20px","margin":"0 auto"}])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(components), (component, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    style: _normalizeStyle({marginTop:(component.gap || 0) + 'px'})
                  }, [
                    (component.type !== _unref(AppConfigComponentType).NAVIGATION_GROUP )
                      ? (_openBlock(), _createBlock(AppConfigComponentDrawerComponent, {
                          key: component.uuid,
                          "is-last-component": index + 1 === _unref(components).length,
                          component: component
                        }, null, 8, ["is-last-component", "component"]))
                      : _createCommentVNode("", true)
                  ], 4))
                }), 256))
              ], 4))
        ], 64))
      : _createCommentVNode("", true)
  ])), [
    [_directive_loading, loading.value]
  ])
}
}

})